import { StateNode, TLStateNodeConstructor } from "tldraw"

import { BucketFill } from "./BucketFill"
import { BucketIdle } from "./BucketIdle"

export class BucketTool extends StateNode {
  static override id = "bucket"
  static override initial = "idle"

  static override isLockable = false
  static override children(): TLStateNodeConstructor[] {
    return [BucketFill, BucketIdle]
  }
}
